import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const PAGE_CONTAINER_PADDING = '1rem 2rem 0';
export const PAGE_CONTAINER_GAP = '1rem';

export const PageContainer = styled(Flex)<FlexProps>`
	flex-direction: column;
	width: 100%;
	height: 100%;
	padding: ${PAGE_CONTAINER_PADDING};
	gap: ${PAGE_CONTAINER_GAP};
`;
